import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
import usePlacesAutocomplete from "use-places-autocomplete";

const GeoLocationInput = ({
  label = "Location",
  placeholder = "Search location",
  value = "",
  onChange,
  disabled = false,
  countryCode = "",
  stateName = "",
  cityName = "",
}) => {
  const {
    ready,
    value: inputValue,
    suggestions: { status, data: suggestions },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
    requestOptions: {
      ...(countryCode
        ? { componentRestrictions: { country: countryCode } }
        : {}),
    },
  });

  useEffect(() => {
    setValue(value || "", false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const normalize = (str) =>
    (str || "")
      .trim()
      .toLowerCase()
      .replace(/\s*(state|province|region|district|county)\s*$/i, "");

  const raw = suggestions || [];
  const filtered = raw.filter((s) => {
    const desc = (s.description || "").toLowerCase();
    if (!desc) return false;
    if (stateName) {
      const st = normalize(stateName);
      if (st && !desc.includes(st)) return false;
    }
    if (cityName) {
      const ct = normalize(cityName);
      if (ct && !desc.includes(ct)) return false;
    }
    return true;
  });
  const shown = filtered.length > 0 ? filtered : raw;

  const handleSelect = (suggestion) => {
    setValue(suggestion.description, false);
    onChange(suggestion.description);
    clearSuggestions();
  };

  const handleInputChange = (e) => {
    const v = e.target.value;

    if (v.trim().length < 3) {
      // Update the input field text without triggering API predictions
      setValue(v, false);
      clearSuggestions();
      if (v.trim() === "") onChange("");
      return;
    }

    // Trigger autocomplete query when 3 or more characters are present
    setValue(v);
  };

  return (
    <Form.Group className="custom-form">
      <Form.Label className="color-head">{label}</Form.Label>
      <div className="pp-geo-location">
        <Form.Control
          type="text"
          className="py-0"
          value={inputValue || value}
          placeholder={placeholder}
          disabled={!ready || disabled}
          onChange={handleInputChange}
          autoComplete="off"
        />
        {inputValue &&
          inputValue.trim().length >= 3 &&
          status === "OK" &&
          shown.length > 0 && (
            <ul className="pp-location-suggestions">
              {shown.map((s) => (
                <li
                  key={s.place_id}
                  className="pp-location-suggestion-item"
                  onClick={() => handleSelect(s)}
                >
                  {s.description}
                </li>
              ))}
            </ul>
          )}
      </div>
    </Form.Group>
  );
};

export default GeoLocationInput;
